<template>
  <div class="player">
    <video playsinline webkit-playsinline>
      <source v-if="url" :src="url" type="video/mp4">
    </video>
    <fullscreen-control :video="video"></fullscreen-control>
    <overlay-play :video="video"></overlay-play>
    <timeline-slider :video="video"></timeline-slider>
  </div>
</template>

<style>
.player {
  position: relative;
}

video {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
}
</style>

<script>
import { mapState, mapMutations } from 'vuex'
import { VIDEO_TIME_UPDATE } from '@/store/mutation-types'
import FullscreenControl from './FullscreenControl'
import OverlayPlay from './OverlayPlay'
import TimelineSlider from './TimelineSlider'

export default {
  components: {
    FullscreenControl,
    OverlayPlay,
    TimelineSlider
  },

  data () {
    return {
      video: {}
    }
  },

  computed: {
    ...mapState({
      url: state => state.video.url,
      seekTime: state => state.video.seek_time,
      currentTime: state => state.video.current_time
    })
  },

  methods: {
    ...mapMutations({
      updateTime: VIDEO_TIME_UPDATE
    })
  },

  watch: {
    seekTime () {
      this.video.currentTime = this.seekTime
    }
  },

  mounted () {
    this.video = this.$el.children[0]
    this.video.addEventListener('timeupdate', () => {
      const seconds = this.video.currentTime
      if (seconds !== this.currentTime && seconds !== this.seekTime) {
        this.updateTime(seconds)
      }
    })
  }
}
</script>




// WEBPACK FOOTER //
// Player.vue?ef917092